<script setup>
import { useModalogStore } from "@/stores/modalog.js";
import BrandButton from "@/Components/Brand/BrandButton.vue";

/**
 * "Delete Account" section of Manage Account (GH-922). The actual deletion
 * flow lives in the existing ModalogDeleteAccount (password confirmation
 * included) — this section just introduces it.
 */
const modalogStore = useModalogStore();

function openDeleteAccountModalog() {
    modalogStore.showModalog({ type: "ModalogDeleteAccount" });
}
</script>

<template>
    <div>
        <h2 class="font-brand text-[25px] font-bold text-[#102a3d]">
            Delete Account
        </h2>
        <p
            class="mt-1 max-w-[640px] font-brand text-[15px] leading-relaxed text-[#3c3938]"
        >
            Once your account is deleted, all of its resources and data will be
            permanently deleted. Before deleting your account, please download
            any data or information that you wish to retain.
        </p>

        <BrandButton
            variant="whiteOnOrange"
            class="mt-8 h-11 px-8 text-[15px]"
            @click="openDeleteAccountModalog"
        >
            Delete Account
        </BrandButton>
    </div>
</template>
